export const MoneyLine1x2 = `
{{var esportsLogoURL = data.esportsLogoURL || '';}}
{{var event_count = 0;}}
{{var options = data.options;}}
{{var defaultEsportsLogoURL = data.defaultEsportsLogoURL || '';}}
{{var isBlockedLiveSport = data.isBlockedLiveSport;}}
{{var blockedLiveLeagues = data.blockedLiveLeagues;}}
{{var periodsRightLayout = data.periodsRightLayout;}}
{{var altMainLabel = data.altMainLabel;}}
{{var periodsDescription = data.periodsDescription;}}

{{? data.sports}}
    {{~data.sports :sp:sp_index}}
    {{var sportGroup =SportGroup.stringOf(sp[4]).toLowerCase();}}
    {{var isSoccerType = sp[4] === SportGroup.SOCCER;}}
    {{var hasDrawML = sp[7];}}
    {{var ot = data.ot;}}
    {{var isParlay = (data.isParlay || data.isParlayMarket);}}
    {{var isEsport = sp[0] == 12;}}
    {{var isTennis = sp[0] == 33;}}
    {{var sportName = sp[1];}}
    {{var isEnableSignUp = data.isEnableSignUp;}}
    <div class='single-line line-1x2 col-{{=hasDrawML?6:4}}'>
    <div class="freeze-table-header"></div>
    <table class="events events-header{{? options.isParlayMarket}} isParlayMarket{{?}} sp{{=sp[0]}}">
        <tr>
            <td class="col-icons main-icons border-left border-bottom col-border-left" rowspan="2"></td>
            <td class="col-time main-time border-bottom-right" rowspan="2">{{=i18n('Time')}}</td>
            <td class="col-fav main-fav border-bottom" rowspan="2"></td>
            <td class='col-name main-name border-bottom-right' rowspan="2"><span>{{=i18n('Event')}}</span></td>
            <td class="main-fulltime border-bottom-right" colspan="{{=!hasDrawML? 2 : 3}} ">{{=getPeriodsName(periodsDescription, sp[0], 0, false)}}</td>
            <td class="main-halftime border-bottom-right" colspan="{{=!hasDrawML? 2 : 3}}">{{=getPeriodsName(periodsDescription, sp[0], periodsRightLayout[0], false)}}</td>
            <td class="col-more main-more border-bottom-right col-border-right" rowspan="2" title="{{=i18n('More')}}">&nbsp;</td>
        </tr>
        <tr>
            <td class="odds main-odds border-bottom-right">{{=isEsport ? i18n('Team 1') : i18n(sportGroup, 'Home')}}</td>
            {{? hasDrawML}}
            <td class="odds main-odds border-bottom-right">{{=i18n(sportGroup, 'Draw')}}</td>
            {{?}}
            <td class="odds main-odds border-bottom-right">{{=isEsport ? i18n('Team 2') : i18n(sportGroup, 'Away')}}</td>
            <td class="odds main-odds border-bottom-right">{{=isEsport ? i18n('Team 1') : i18n(sportGroup, 'Home')}}</td>
            {{? hasDrawML}}
            <td class="odds main-odds border-bottom-right">{{=i18n(sportGroup, 'Draw')}}</td>
            {{?}}
            <td class="odds main-odds border-bottom-right">{{=isEsport ? i18n('Team 2') : i18n(sportGroup, 'Away')}}</td>
        </tr>
    </table>
    {{var leagues = sp[2];}}
    {{var images = {};}}
    {{~leagues :lg:lg_index}}
    {{var leagueName = lg[1];}}
    {{var leagueId = lg[0];}}
    {{var isBlockedLiveLeague = blockedLiveLeagues.indexOf(leagueId) > -1;}}
    <div class="league" id='lg{{=leagueId}}'>
        <a class="bookmark "><i data-league-id="{{=leagueId}}" class='fav  icon'></i></a>
        <div class="fav-custom-tooltip ">
            <div class="tooltip-wrapper">
                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
            </div>
        </div>
        <span>
        {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
        {{? isEsport && originalLeagueName}}
            {{var category = originalLeagueName.indexOf('-') > -1 ? originalLeagueName.split('-')[0].trim() : 'others';}}
            {{var code = category.toLowerCase().replaceAll(' ', '').replaceAll(':', '');}}
            {{var url = esportsLogoURL.concat(code, '/league/', leagueId, '.png');}}
            {{var gameUrl = '';}}
            {{ var clazzName = 'i'.concat(leagueId);}}
            {{
                images[leagueId] = new Image();
                images[leagueId].dataset.id = leagueId;
                images[leagueId].onload = function() {
                    var dotImgOrEmpty = (this.width == 1 && this.height == 1) || (this.width == 0 && this.height == 0);
                    var className = 'sport-icon icon-default ';
                    var el = document.getElementsByClassName('i'.concat(this.dataset.id));
                    if (!dotImgOrEmpty) {                        
                        if (el.length == 1) {
                        el[0].style.backgroundImage  =  'url(' + this.src + ')';
                        } else if (el.length > 1) {
                            for (var i=0; i < el.length; i++) {
                                el[i].style.backgroundImage  =  'url(' + this.src + ')';
                            }
                        }
                    } else {                
                        if (el.length == 1) {
                            el[0].className  =  className + 'icon-' + this.code;
                        } else if (el.length > 1) {
                            for (var i=0; i < el.length; i++) {
                                el[i].className  = className + 'icon-' + this.code;
                            }
                        }
                    }
                };
                images[leagueId].onerror = function() {   
                    var className = 'sport-icon icon-default ';
                    var el = document.getElementsByClassName('i'.concat(this.dataset.id));
                    if (el.length == 1) {
                        el[0].className  =  className + 'icon-' + this.code;
                    } else if (el.length > 1) {
                        for (var i=0; i < el.length; i++) {
                            el[i].className  = className + 'icon-' + this.code;
                        }
                    }
                      
                };
                images[leagueId].src = url;
                images[leagueId].code = code;
            }}
            <div class="league-icon {{=clazzName}}">
            </div>
        {{?}}
        {{=leagueName}}
        </span>
        <a class="refresh-odds" data-live="{{=data.isLive}}"><i class='icon refresh-odds'></i></a>
    </div>
    <div>
    {{~lg[2] :ev:ev_index}}
    <table class="events no-select events-list sp{{=sp[0]}} border-bottom col-border-bottom" id="e{{=ev[0]}}">
        {{var event_count = event_count + 1;}}
        {{var ft = ev[8][0];}}
        {{var ht = ev[8][periodsRightLayout[0]];}}
        {{var ft1x2 = ft && ft[0];}}
        {{var ht1x2 = ht && ht[0];}}
        
        {{var isFT1x2Online = ft1x2 && ft1x2[1] != '';}}
        {{var isHT1x2Online = ht1x2 && ht1x2[1] != '';}}
        {{var statusPeriodsLeftSide = ft && ft[9] ? "status_" + ft[9] : "";}}
        {{var statusPeriodsRightSide = ht && ht[9] ? "status_" + ht[9] : "";}}

        {{var _moreBetsCount = ev[7] + (isParlay ? 0 : ev[23]);}}
        <tr class='{{=event_count%2==0?"even":"odd"}} mkline e{{=ev[0]}}' id="e{{=ev[0]}}_0" {{? _moreBetsCount > 0}}data-eid="{{=ev[0]}}"{{?}}>
            <td class='col-icons main-icons border-left col-border-left'>
            </td>
            <td class='col-time main-time border-right'>
                {{? ev[5]}}
                    {{? ev[9]}}
                        <span>{{=ev[9][0]}}-{{=ev[9][1]}}</span>
                    {{??}}
                        {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span> {{?}}
                    {{?}}
                    {{? ev[16]}}
                        <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                    {{??}}
                        <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                    {{?}}
                {{??}}
                    {{? ev[6] && !isBlockedLiveSport && !isBlockedLiveLeague}}
                        <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                        {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                    {{??}}
                        <span>{{=moment(new DateTZ(ev[4])).format(i18n('MM/DD'))}}</span>
                        <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                    {{?}}
                {{?}}
            </td>
            <td class='col-fav main-fav'>
                <a class="bookmark" data-event-id="{{=ev[0]}}" ><i class='fav  icon'></i></a>
                <div class="fav-custom-tooltip ">
                    <div class="tooltip-wrapper">
                        <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
                    </div>
                </div>
            </td>
            <td class='{{=ht&&(ht[3]||ht[4])? "": "no-underdog"}} col-name main-name border-right {{=ev[18] || ev[19] ? "lc-icons": ""}}'>
                {{? isTennis && !ev[29] && ev[27] && ev[27].toLowerCase() != 'regular' }}
                    <div class="grading-unit-container">
                        ({{=i18n(ev[27])}})
                    </div>
                {{?}}
                <div class="team-name-container">
                    <span title="{{=ev[1]}}" class="{{=ht&&ht[3]? 'favSel':'sel'}}">
                    {{? isEsport}}
                        {{var homeName = ev[24].toLowerCase().replaceAll(' ', '_');}}
                        {{var url = esportsLogoURL.concat(code, '/team/', homeName, '.png');}}
                        <span class="logo"><img class="sport-icon" src='{{=url}}' onerror="this.style.display='none'"/></span>
                    {{?}}
                        {{? ev[5] && ev[10]&& ev[10][0]}}<i class="card redCard">{{=ev[10][0]}}</i>{{?}}{{=ev[1]}}&lrm;
                    </span>
                    <span title="{{=ev[2]}}" class="{{=ht&&ht[4]? 'favSel':'sel'}}">
                    {{? isEsport}}
                        {{var awayName = ev[25].toLowerCase().replaceAll(' ', '_');}}
                        {{var url = esportsLogoURL.concat(code, '/team/', awayName, '.png');}}
                        <span class="logo"><img class="sport-icon" src='{{=url}}' onerror="this.style.display='none'"/></span>
                    {{?}}
                        {{? ev[5] && ev[10]&& ev[10][1]}}<i class="card redCard">{{=ev[10][1]}}</i>{{?}}{{=ev[2]}}&lrm;
                    </span>
                </div>
            </td>
            <td class="odds main-odds {{=statusPeriodsLeftSide}}" data-period='0'>
                {{? isFT1x2Online}}
                <a class="odds {{=ft1x2[1] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ft1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|0|1|0|{{=ft1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ft1x2[1] > 0}}+{{?}}{{=ft1x2[1]}}</span>
                    {{??}}
                        <span>{{=ft1x2[1].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            {{? hasDrawML}}
            <td class="odds main-odds {{=statusPeriodsLeftSide}}" data-period='0'>
                {{? isFT1x2Online && ft1x2[2]}}
                <a class="odds {{=ft1x2[2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ft1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="2"
                id="{{=ev[0]}}|0|1|2|{{=ft1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ft1x2[2] > 0}}+{{?}}{{=ft1x2[2]}}</span>
                    {{??}}
                        <span>{{=ft1x2[2].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            {{?}}
            <td class="odds main-odds {{=statusPeriodsLeftSide}}" data-period='0'>
                {{? isFT1x2Online}}
                <a class="odds {{=ft1x2[0] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ft1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|0|1|1|{{=ft1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ft1x2[0] > 0}}+{{?}}{{=ft1x2[0]}}</span>                        
                    {{??}}
                        <span>{{=ft1x2[0].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            <td class="odds main-odds border-left {{=statusPeriodsRightSide}}" data-period='{{=periodsRightLayout[0]}}'>
                {{? isHT1x2Online}}
                <a class="odds {{=ht1x2[1] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ht1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|{{=periodsRightLayout[0]}}|1|0|{{=ht1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ht1x2[1] > 0}}+{{?}}{{=ht1x2[1]}}</span>
                    {{??}}
                        <span>{{=ht1x2[1].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            {{? hasDrawML}}
            <td class="odds main-odds {{=statusPeriodsRightSide}}" data-period='{{=periodsRightLayout[0]}}'>
                {{? isHT1x2Online && ht1x2[2]}}
                <a class="odds {{=ht1x2[2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ht1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="2"
                id="{{=ev[0]}}|{{=periodsRightLayout[0]}}|1|2|{{=ht1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ht1x2[2] > 0}}+{{?}}{{=ht1x2[2]}}</span>
                    {{??}}
                        <span>{{=ht1x2[2].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            {{?}}
            <td class="odds main-odds {{=statusPeriodsRightSide}}" data-period='{{=periodsRightLayout[0]}}'>
                {{? isHT1x2Online}}
                <a class="odds {{=ht1x2[0] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=ht1x2[3]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|{{=periodsRightLayout[0]}}|1|1|{{=ht1x2[4]?1:0}}|0"
                >
                    {{? ot === OddsFormat.American}}
                        <span>{{? ht1x2[0] > 0}}+{{?}}{{=ht1x2[0]}}</span>
                    {{??}}
                            <span>{{=ht1x2[0].formatSeparators()}}</span>
                    {{?}}
                </a>
                {{??}}&nbsp;
                {{?}}
            </td>
            <td class='col-more main-more border-right border-left col-border-right'>
                <div class='more-content'>
                    {{? ev[31] }}
                        <!-- Has stats -->
                        <span class="icons stats-icon">
                            <i class="stats"
                            data-live="{{=ev[20]}}"
                            data-event="{{=ev[0]}}"
                            data-league-id="{{=leagueId}}"
                            data-home-team="{{=ev[1]}}"
                            data-away-team="{{=ev[2]}}"
                            data-sport-name="{{=sportName}}"
                            data-league-name="{{=leagueName}}"
                            >
                            </i>
                        </span>
                    {{?}}
                    {{? _moreBetsCount > 0}}
                        {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
                        <span id='more_{{=ev[0]}}' class='more' data-eid="{{=ev[0]}}" data-league-name="{{=originalLeagueName}}">
                            <span class='more-loading'><i class='fa fa-sync fa-spin'></i></span>
                            <span class='sign'>+</span>
                            <span class="more-count">
                                {{=_moreBetsCount}}
                            </span>
                        </span>
                    {{?}}
                </div>
            </td>
        </tr>
        <tr class="more-bets {{=event_count%2==0?"even":"odd"}}" id="e{{=ev[0]}}_more"><td class="more-bets" colspan="{{=!hasDrawML? 9 : 11}}"></td></tr>
        </table>
        {{~}}<!--Events-->
        </div>
        {{~}}<!--Leagues-->
        {{? leagues.length ==0}}
            <div class="no-event">{{=i18n('No Events')}}</div>
        {{?}}
    </div>
    {{~}}<!--Sports-->
{{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/MoneyLine1x2.js